import { chipClasses } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: () => {
      return {
        color: "inherit",
        lineHeight: "inherit",
        borderRadius: "var(--mui-shape-borderRadius)",
        border: "1px solid var(--mui-palette-Chip-defaultBorder)",

        [`&.${chipClasses.colorSuccess}`]: {
          background: `light-dark(var(--mui-palette-success-lightest), var(--mui-palette-success-contrastText))`,
          borderColor: `light-dark(--transparent(var(--mui-palette-success-light)), var(--mui-palette-success-light))`,
        },

        [`&.${chipClasses.colorError}`]: {
          background: `light-dark(var(--mui-palette-error-light), var(--mui-palette-error-contrastText))`,
          borderColor: `light-dark(--transparent(var(--mui-palette-error-main)), var(--mui-palette-error-main))`,
        },

        [`&.${chipClasses.colorWarning}`]: {
          background: `light-dark(var(--mui-palette-warning-lightest), var(--mui-palette-warning-contrastText))`,
          borderColor: `light-dark(--transparent(var(--mui-palette-warning-light)), var(--mui-palette-warning-light))`,
        },

        [`&.${chipClasses.colorInfo}`]: {
          background: `light-dark(var(--mui-palette-info-lightest), var(--mui-palette-info-contrastText))`,
          borderColor: `light-dark(var(--mui-palette-info-light), var(--mui-palette-info-main))`,
        },
      };
    },
  },
};
